import {useLayoutEffect, useState} from "react";

export function isMobileHook(mobileBreakPoint) {
	const [isMobile, setIsMobile] = useState(window.innerWidth < mobileBreakPoint);

	useLayoutEffect(() => {
		window.addEventListener('resize', () => {
			const isMobileTMP = window.innerWidth < mobileBreakPoint;
			if (isMobile !== isMobileTMP) {
				setIsMobile(isMobileTMP);
			}
		}, false);
	}, [isMobile])

	return isMobile;
}
